import { render, staticRenderFns } from "./VendorSelect.vue?vue&type=template&id=e2e9b64c&"
import script from "./VendorSelect.vue?vue&type=script&lang=ts&"
export * from "./VendorSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports